import type { ReactNode } from 'react';

import { Box, type SxProps, type Theme, Typography } from '@mui/material';

export type EntityCardStatistic = {
	label: string;
	value: ReactNode;
};

type EntityCardStatisticsProps = {
	items: EntityCardStatistic[];
	sx?: SxProps<Theme>;
};

/** Equal-width, divided statistic row shared by gallery entity cards. */
export default function EntityCardStatistics({ items, sx }: EntityCardStatisticsProps) {
	return (
		<Box
			sx={[
				{
					display: 'grid',
					gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
					mt: 1.5,
					color: 'text.primary',
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : []),
			]}
		>
			{items.map((item) => (
				<Box key={item.label} sx={{ minWidth: 0, px: 0.25, textAlign: 'center', '&:not(:last-child)': { borderRight: 1, borderColor: 'divider' } }}>
					<Typography variant="subtitle2" color="text.primary" fontWeight={600}>
						{item.value}
					</Typography>
					<Typography variant="caption" color="text.secondary" noWrap sx={{ fontSize: '0.68rem' }}>
						{item.label}
					</Typography>
				</Box>
			))}
		</Box>
	);
}
